import size from 'lodash/size';
import ceil from 'lodash/ceil';
export const calculateIndexRange = (currentPage, recordCount) => {
    let begin = currentPage === 1 ? 0 : ((currentPage - 1) * recordCount);
    let end = begin + recordCount;
    return { begin, end }
}
